export class FullscreenManager {
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
    
    // Add fullscreen change event listeners
    document.addEventListener('fullscreenchange', () => this.handleResize());
    document.addEventListener('webkitfullscreenchange', () => this.handleResize());
    document.addEventListener('mozfullscreenchange', () => this.handleResize());
    document.addEventListener('MSFullscreenChange', () => this.handleResize());
  }

  public enterFullscreen(): void {
    if (this.container.requestFullscreen) {
      this.container.requestFullscreen();
    } else if ((this.container as any).webkitRequestFullscreen) {
      (this.container as any).webkitRequestFullscreen();
    } else if ((this.container as any).msRequestFullscreen) {
      (this.container as any).msRequestFullscreen();
    }
  }

  public exitFullscreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  }

  public handleResize(): void {
    // This method is called when fullscreen state changes
    // It can be used to handle any necessary resize logic
  }
} 